export default __webpack_public_path__ + "assets/lunav-component.0a597922.svg";